import group from "@/components/common/i18n/system/group"

export default {
    zh:{
        group:group.zh
    },
    en:{
        group:group.en
    }
}
